module.exports = __webpack_public_path__ + "img/Background_Image.deebabdb.deebabdb.jpg";